export enum PortalStructure {
  'Div' = 1,
  'Country' = 2
}
